<div class="container-fluid">
  <!-- Navigation tabs -->
  <div class="row mb-4">
    <div class="col-12">
      <ul class="nav nav-tabs" id="complaintsTabs" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link" [class.active]="activeTab === 'stars'" (click)="setActiveTab('stars')" type="button">
            <i class="fas fa-star me-2"></i>
            Plaintes des Stars
            <span class="badge bg-warning ms-2">{{ starComplaints.length }}</span>
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" [class.active]="activeTab === 'fans'" (click)="setActiveTab('fans')" type="button">
            <i class="fas fa-users me-2"></i>
            Plaintes des Fans
            <span class="badge bg-primary ms-2">{{ fanComplaints.length }}</span>
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" [class.active]="activeTab === 'platforms'" (click)="setActiveTab('platforms')"
            type="button">
            <i class="fas fa-cog me-2"></i>
            Plaintes des Plateformes
            <span class="badge bg-dark ms-2">{{ platformComplaints.length }}</span>
          </button>
        </li>
      </ul>
    </div>
  </div>

  <!-- Loading state -->
  <div class="row" *ngIf="isLoading">
    <div class="col-12 text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Chargement...</span>
      </div>
    </div>
  </div>

  <!-- Stars complaints tab -->
  <div class="row" *ngIf="!isLoading && shouldShowStarsTab()">
    <div class="col-12">
      <div class="card star-section">
        <div class="card-header star-header">
          <h4 class="card-title mb-0">
            <i class="fas fa-star me-2"></i>
            Plaintes des Stars
            <span class="badge bg-warning ms-2">{{ starComplaints.length }}</span>
          </h4>
        </div>
        <div class="card-body">
          <div class="table-container">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Auteur</th>
                  <th>Cible</th>
                  <th class="text-center">Type</th>
                  <th class="text-center">Référence</th>
                  <th class="text-center">Statut</th>
                  <th class="text-center">Date</th>
                  <th class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let complaint of getPaginatedStarComplaints()">
                  <td class="align-middle">
                    <div class="d-flex align-items-center" *ngIf="complaint.user">
                      <img
                        *ngIf="(isCurrentUser(complaint.user.id) ? currentUser.profile_picture : isValidImage(complaint.user.profile_picture)) && !complaint.user._hideImage; else userInitStar"
                        [src]="isCurrentUser(complaint.user.id) ? (currentUser.profile_picture || currentUser.avatar) : complaint.user.profile_picture"
                        (error)="onImageError(complaint.user)" class="rounded-circle me-2"
                        style="width: 32px; height: 32px; object-fit: cover;" [alt]="complaint.user.name">
                      <ng-template #userInitStar>
                        <div class="avatar-initial me-2"
                          [style.background-color]="getAvatarColor(getDisplayName(complaint.user))">
                          {{ getAvatarInitial(getDisplayName(complaint.user)) }}
                        </div>
                      </ng-template>
                      <div style="min-width: 0;">
                        <div class="fw-bold text-truncate" style="max-width: 150px;"
                          [title]="isCurrentUser(complaint.user.id) ? 'Vous' : (complaint.user.prenom + ' ' + complaint.user.nom)">
                          {{ isCurrentUser(complaint.user.id) ? 'Vous' : (complaint.user.prenom + ' ' +
                          complaint.user.nom) }}
                        </div>
                        <small class="text-muted d-block text-truncate" style="max-width: 150px;"
                          *ngIf="!isCurrentUser(complaint.user.id)">{{ complaint.user.email }}</small>
                      </div>
                    </div>
                  </td>
                  <td class="align-middle">
                    <div class="d-flex align-items-center" *ngIf="complaint.against">
                      <img
                        *ngIf="isValidImage(complaint.against.profile_picture) && !complaint.against._hideImage; else againstInitStar"
                        [src]="complaint.against.profile_picture" (error)="onImageError(complaint.against)"
                        class="rounded-circle me-2" style="width: 32px; height: 32px; object-fit: cover;"
                        [alt]="complaint.against.name">
                      <ng-template #againstInitStar>
                        <div class="avatar-initial me-2"
                          [style.background-color]="getAvatarColor(getDisplayName(complaint.against))">
                          {{ getAvatarInitial(getDisplayName(complaint.against)) }}
                        </div>
                      </ng-template>
                      <div style="min-width: 0;">
                        <div class="fw-bold text-truncate" style="max-width: 150px;"
                          [title]="complaint.against.scene_name || (complaint.against.prenom + ' ' + complaint.against.nom)">
                          {{ complaint.against.scene_name || (complaint.against.prenom + ' ' + complaint.against.nom) }}
                        </div>
                        <span class="badge bg-light text-dark border p-1"><small>{{ complaint.against.rang
                            }}</small></span>
                      </div>
                    </div>
                    <span *ngIf="!complaint.against" class="text-muted">Plateforme</span>
                  </td>
                  <td class="text-center align-middle">
                    <span class="badge" [ngClass]="getTypeBadgeClass(complaint.type)">
                      {{ getTypeLabel(complaint.type) }}
                    </span>
                  </td>
                  <td class="text-center align-middle">
                    <div class="fw-bold text-nowrap">{{ complaint.reference || '-' }}</div>
                    <small class="text-muted d-block" *ngIf="complaint.payment_reference">{{ complaint.payment_reference
                      }}</small>
                  </td>
                  <td class="text-center align-middle">
                    <span class="status-badge" [ngClass]="getStatusDisplay(complaint.status).class">
                      {{ getStatusDisplay(complaint.status).text }}
                    </span>
                  </td>
                  <td class="text-center align-middle">{{ formatDate(complaint.created_at) }}</td>
                  <td class="text-center align-middle action-style">
                    <div class="btn-group" role="group">
                      <!-- Validation Initiale -->
                      <button class="btn btn-sm btn-success"
                        *ngIf="getAvailableActions(complaint.status).includes('validate')"
                        (click)="validateComplaint(complaint)" title="Valider la plainte">
                        <i class="fas fa-check"></i>
                      </button>

                      <!-- Rejet -->
                      <button class="btn btn-sm btn-danger"
                        *ngIf="getAvailableActions(complaint.status).includes('reject')"
                        (click)="rejectComplaint(complaint)" title="Rejeter la plainte">
                        <i class="fas fa-times"></i>
                      </button>

                      <!-- Démarrer l'analyse -->
                      <button class="btn btn-sm btn-info"
                        *ngIf="getAvailableActions(complaint.status).includes('start_analysis')"
                        (click)="startAnalysis(complaint)" title="Démarrer l'analyse">
                        <i class="fas fa-search"></i>
                      </button>

                      <!-- Résoudre -->
                      <button class="btn btn-sm btn-success"
                        *ngIf="getAvailableActions(complaint.status).includes('resolve')"
                        (click)="resolveComplaint(complaint)" title="Résoudre la plainte">
                        <i class="fas fa-check-circle"></i>
                      </button>

                      <!-- Fermer -->
                      <button class="btn btn-sm btn-secondary"
                        *ngIf="getAvailableActions(complaint.status).includes('close')"
                        (click)="closeComplaint(complaint)" title="Fermer la plainte">
                        <i class="fas fa-lock"></i>
                      </button>

                      <!-- Voir détails -->
                      <button class="btn btn-sm btn-primary" (click)="openDetailModal(complaint)"
                        title="Voir les détails">
                        <i class="fas fa-eye"></i>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="starComplaints.length === 0">
                  <td colspan="7" class="text-center text-muted">Aucune plainte de star trouvée</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Pagination -->
        <div class="pagination-wrapper" *ngIf="starPagination.total > 0">
          <div class="row align-items-center">
            <div class="col-md-6">
              <div class="pagination-info">
                <span>Affichage de {{ getCurrentPagination().from }} à {{ getCurrentPagination().to }} sur {{
                  getCurrentPagination().total }} plaintes</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex justify-content-end align-items-center">
                <select class="form-select me-3" style="width: auto;"
                  (change)="changePerPage($any($event.target).value)">
                  <option value="5" [selected]="getCurrentPagination().per_page === 5">5</option>
                  <option value="10" [selected]="getCurrentPagination().per_page === 10">10</option>
                  <option value="25" [selected]="getCurrentPagination().per_page === 25">25</option>
                  <option value="50" [selected]="getCurrentPagination().per_page === 50">50</option>
                </select>

                <nav aria-label="Pagination">
                  <ul class="pagination mb-0">
                    <li class="page-item" [class.disabled]="getCurrentPagination().current_page === 1">
                      <button class="page-link" (click)="changePage(getCurrentPagination().current_page - 1)"
                        [disabled]="getCurrentPagination().current_page === 1">
                        <i class="fas fa-chevron-left"></i>
                      </button>
                    </li>

                    <li class="page-item" *ngFor="let page of getPageNumbers()"
                      [class.active]="page === getCurrentPagination().current_page">
                      <button class="page-link" (click)="changePage(page)">{{ page }}</button>
                    </li>

                    <li class="page-item" [class.disabled]="pagination.current_page === pagination.last_page">
                      <button class="page-link" (click)="changePage(getCurrentPagination().current_page + 1)"
                        [disabled]="getCurrentPagination().current_page === getCurrentPagination().last_page">
                        <i class="fas fa-chevron-right"></i>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Fans complaints tab -->
  <div class="row" *ngIf="!isLoading && shouldShowFansTab()">
    <div class="col-12">
      <div class="card fan-section">
        <div class="card-header fan-header">
          <h4 class="card-title mb-0">
            <i class="fas fa-users me-2"></i>
            Plaintes des Fans
            <span class="badge bg-primary ms-2">{{ fanComplaints.length }}</span>
          </h4>
        </div>
        <div class="card-body">
          <div class="table-container">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Auteur</th>
                  <th>Cible</th>
                  <th class="text-center">Type</th>
                  <th class="text-center">Référence</th>
                  <th class="text-center">Statut</th>
                  <th class="text-center">Date</th>
                  <th class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let complaint of getPaginatedFanComplaints()">
                  <td class="align-middle">
                    <div class="d-flex align-items-center" *ngIf="complaint.user">
                      <img
                        *ngIf="(isCurrentUser(complaint.user.id) ? currentUser.profile_picture : isValidImage(complaint.user.profile_picture)) && !complaint.user._hideImage; else userInitFan"
                        [src]="isCurrentUser(complaint.user.id) ? (currentUser.profile_picture || currentUser.avatar) : complaint.user.profile_picture"
                        (error)="onImageError(complaint.user)" class="rounded-circle me-2"
                        style="width: 32px; height: 32px; object-fit: cover;" [alt]="complaint.user.name">
                      <ng-template #userInitFan>
                        <div class="avatar-initial me-2"
                          [style.background-color]="getAvatarColor(getDisplayName(complaint.user))">
                          {{ getAvatarInitial(getDisplayName(complaint.user)) }}
                        </div>
                      </ng-template>
                      <div style="min-width: 0;">
                        <div class="fw-bold text-truncate" style="max-width: 150px;"
                          [title]="isCurrentUser(complaint.user.id) ? 'Vous' : (complaint.user.prenom + ' ' + complaint.user.nom)">
                          {{ isCurrentUser(complaint.user.id) ? 'Vous' : (complaint.user.prenom + ' ' +
                          complaint.user.nom) }}
                        </div>
                        <small class="text-muted d-block text-truncate" style="max-width: 150px;"
                          *ngIf="!isCurrentUser(complaint.user.id)">{{ complaint.user.email }}</small>
                      </div>
                    </div>
                  </td>
                  <td class="align-middle">
                    <div class="d-flex align-items-center" *ngIf="complaint.against">
                      <img
                        *ngIf="isValidImage(complaint.against.profile_picture) && !complaint.against._hideImage; else againstInitFan"
                        [src]="complaint.against.profile_picture" (error)="onImageError(complaint.against)"
                        class="rounded-circle me-2" style="width: 32px; height: 32px; object-fit: cover;"
                        [alt]="complaint.against.name">
                      <ng-template #againstInitFan>
                        <div class="avatar-initial me-2"
                          [style.background-color]="getAvatarColor(getDisplayName(complaint.against))">
                          {{ getAvatarInitial(getDisplayName(complaint.against)) }}
                        </div>
                      </ng-template>
                      <div style="min-width: 0;">
                        <div class="fw-bold text-truncate" style="max-width: 150px;"
                          [title]="complaint.against.scene_name || (complaint.against.prenom + ' ' + complaint.against.nom)">
                          {{ complaint.against.scene_name || (complaint.against.prenom + ' ' + complaint.against.nom) }}
                        </div>
                        <span class="badge bg-light text-dark border p-1"><small>{{ complaint.against.rang
                            }}</small></span>
                      </div>
                    </div>
                    <span *ngIf="!complaint.against" class="text-muted">Plateforme</span>
                  </td>
                  <td class="text-center align-middle">
                    <span class="badge" [ngClass]="getTypeBadgeClass(complaint.type)">
                      {{ getTypeLabel(complaint.type) }}
                    </span>
                  </td>
                  <td class="text-center align-middle">
                    <div class="fw-bold text-nowrap">{{ complaint.reference || '-' }}</div>
                    <small class="text-muted d-block" *ngIf="complaint.payment_reference">{{ complaint.payment_reference
                      }}</small>
                  </td>
                  <td class="text-center align-middle">
                    <span class="status-badge" [ngClass]="getStatusDisplay(complaint.status).class">
                      {{ getStatusDisplay(complaint.status).text }}
                    </span>
                  </td>
                  <td class="text-center align-middle">{{ formatDate(complaint.created_at) }}</td>
                  <td class="text-center align-middle action-style">
                    <div class="btn-group" role="group">
                      <!-- Validation Initiale -->
                      <button class="btn btn-sm btn-success"
                        *ngIf="getAvailableActions(complaint.status).includes('validate')"
                        (click)="validateComplaint(complaint)" title="Valider la plainte">
                        <i class="fas fa-check"></i>
                      </button>

                      <!-- Rejet -->
                      <button class="btn btn-sm btn-danger"
                        *ngIf="getAvailableActions(complaint.status).includes('reject')"
                        (click)="rejectComplaint(complaint)" title="Rejeter la plainte">
                        <i class="fas fa-times"></i>
                      </button>

                      <!-- Démarrer l'analyse -->
                      <button class="btn btn-sm btn-info"
                        *ngIf="getAvailableActions(complaint.status).includes('start_analysis')"
                        (click)="startAnalysis(complaint)" title="Démarrer l'analyse">
                        <i class="fas fa-search"></i>
                      </button>

                      <!-- Résoudre -->
                      <button class="btn btn-sm btn-success"
                        *ngIf="getAvailableActions(complaint.status).includes('resolve')"
                        (click)="resolveComplaint(complaint)" title="Résoudre la plainte">
                        <i class="fas fa-check-circle"></i>
                      </button>

                      <!-- Fermer -->
                      <button class="btn btn-sm btn-secondary"
                        *ngIf="getAvailableActions(complaint.status).includes('close')"
                        (click)="closeComplaint(complaint)" title="Fermer la plainte">
                        <i class="fas fa-lock"></i>
                      </button>

                      <!-- Voir détails -->
                      <button class="btn btn-sm btn-primary" (click)="openDetailModal(complaint)"
                        title="Voir les détails">
                        <i class="fas fa-eye"></i>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="fanComplaints.length === 0">
                  <td colspan="7" class="text-center text-muted">Aucune plainte de fan trouvée</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Pagination -->
        <div class="pagination-wrapper" *ngIf="starPagination.total > 0">
          <div class="row align-items-center">
            <div class="col-md-6">
              <div class="pagination-info">
                <span>Affichage de {{ getCurrentPagination().from }} à {{ getCurrentPagination().to }} sur {{
                  getCurrentPagination().total }} plaintes</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex justify-content-end align-items-center">
                <select class="form-select me-3" style="width: auto;"
                  (change)="changePerPage($any($event.target).value)">
                  <option value="5" [selected]="getCurrentPagination().per_page === 5">5</option>
                  <option value="10" [selected]="getCurrentPagination().per_page === 10">10</option>
                  <option value="25" [selected]="getCurrentPagination().per_page === 25">25</option>
                  <option value="50" [selected]="getCurrentPagination().per_page === 50">50</option>
                </select>

                <nav aria-label="Pagination">
                  <ul class="pagination mb-0">
                    <li class="page-item" [class.disabled]="getCurrentPagination().current_page === 1">
                      <button class="page-link" (click)="changePage(getCurrentPagination().current_page - 1)"
                        [disabled]="getCurrentPagination().current_page === 1">
                        <i class="fas fa-chevron-left"></i>
                      </button>
                    </li>

                    <li class="page-item" *ngFor="let page of getPageNumbers()"
                      [class.active]="page === getCurrentPagination().current_page">
                      <button class="page-link" (click)="changePage(page)">{{ page }}</button>
                    </li>

                    <li class="page-item" [class.disabled]="pagination.current_page === pagination.last_page">
                      <button class="page-link" (click)="changePage(getCurrentPagination().current_page + 1)"
                        [disabled]="getCurrentPagination().current_page === getCurrentPagination().last_page">
                        <i class="fas fa-chevron-right"></i>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Platform complaints tab -->
  <div class="row" *ngIf="!isLoading && shouldShowPlatformsTab()">
    <div class="col-12">
      <div class="card platform-section">
        <div class="card-header platform-header">
          <h4 class="card-title mb-0">
            <i class="fas fa-cog me-2"></i>
            Plaintes des Plateformes
            <span class="badge bg-dark ms-2">{{ platformComplaints.length }}</span>
          </h4>
        </div>
        <div class="card-body">
          <div class="table-container">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Auteur</th>
                  <th>Cible</th>
                  <th class="text-center">Type</th>
                  <th class="text-center">Référence</th>
                  <th class="text-center">Statut</th>
                  <th class="text-center">Date</th>
                  <th class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let complaint of getPaginatedPlatformComplaints()">
                  <td class="align-middle">
                    <div class="d-flex align-items-center" *ngIf="complaint.user">
                      <img
                        *ngIf="(isCurrentUser(complaint.user.id) ? currentUser.profile_picture : isValidImage(complaint.user.profile_picture)) && !complaint.user._hideImage; else userInitPlatform"
                        [src]="isCurrentUser(complaint.user.id) ? (currentUser.profile_picture || currentUser.avatar) : complaint.user.profile_picture"
                        (error)="onImageError(complaint.user)" class="rounded-circle me-2"
                        style="width: 32px; height: 32px; object-fit: cover;" [alt]="complaint.user.name">
                      <ng-template #userInitPlatform>
                        <div class="avatar-initial me-2"
                          [style.background-color]="getAvatarColor(getDisplayName(complaint.user))">
                          {{ getAvatarInitial(getDisplayName(complaint.user)) }}
                        </div>
                      </ng-template>
                      <div style="min-width: 0;">
                        <div class="fw-bold text-truncate" style="max-width: 150px;"
                          [title]="isCurrentUser(complaint.user.id) ? 'Vous' : (complaint.user.prenom + ' ' + complaint.user.nom)">
                          {{ isCurrentUser(complaint.user.id) ? 'Vous' : (complaint.user.prenom + ' ' +
                          complaint.user.nom) }}
                        </div>
                        <small class="text-muted d-block text-truncate" style="max-width: 150px;"
                          *ngIf="!isCurrentUser(complaint.user.id)">{{ complaint.user.email }}</small>
                      </div>
                    </div>
                  </td>
                  <td class="align-middle">
                    <div class="d-flex align-items-center" *ngIf="complaint.against">
                      <img
                        *ngIf="isValidImage(complaint.against.profile_picture) && !complaint.against._hideImage; else againstInitPlatform"
                        [src]="complaint.against.profile_picture" (error)="onImageError(complaint.against)"
                        class="rounded-circle me-2" style="width: 32px; height: 32px; object-fit: cover;"
                        [alt]="complaint.against.name">
                      <ng-template #againstInitPlatform>
                        <div class="avatar-initial me-2"
                          [style.background-color]="getAvatarColor(getDisplayName(complaint.against))">
                          {{ getAvatarInitial(getDisplayName(complaint.against)) }}
                        </div>
                      </ng-template>
                      <div>
                        <div class="fw-bold">{{ complaint.against.scene_name || (complaint.against.prenom + ' ' +
                          complaint.against.nom) }}</div>
                        <span class="badge bg-light text-dark border p-1"><small>{{ complaint.against.rang
                            }}</small></span>
                      </div>
                    </div>
                    <span *ngIf="!complaint.against" class="text-muted">Plateforme</span>
                  </td>
                  <td class="text-center align-middle">
                    <span class="badge" [ngClass]="getTypeBadgeClass(complaint.type)">
                      {{ getTypeLabel(complaint.type) }}
                    </span>
                  </td>
                  <td class="text-center align-middle">
                    <div class="fw-bold text-nowrap">{{ complaint.reference || '-' }}</div>
                    <small class="text-muted d-block" *ngIf="complaint.payment_reference">{{ complaint.payment_reference
                      }}</small>
                  </td>
                  <td class="text-center align-middle">
                    <span class="status-badge" [ngClass]="getStatusDisplay(complaint.status).class">
                      {{ getStatusDisplay(complaint.status).text }}
                    </span>
                  </td>
                  <td class="text-center align-middle">{{ formatDate(complaint.created_at) }}</td>
                  <td class="text-center align-middle">
                    <div class="btn-group" role="group">
                      <!-- Validation Initiale -->
                      <button class="btn btn-sm btn-success"
                        *ngIf="getAvailableActions(complaint.status).includes('validate')"
                        (click)="validateComplaint(complaint)" title="Valider la plainte">
                        <i class="fas fa-check"></i>
                      </button>

                      <!-- Rejet -->
                      <button class="btn btn-sm btn-danger"
                        *ngIf="getAvailableActions(complaint.status).includes('reject')"
                        (click)="rejectComplaint(complaint)" title="Rejeter la plainte">
                        <i class="fas fa-times"></i>
                      </button>

                      <!-- Démarrer l'analyse -->
                      <button class="btn btn-sm btn-info"
                        *ngIf="getAvailableActions(complaint.status).includes('start_analysis')"
                        (click)="startAnalysis(complaint)" title="Démarrer l'analyse">
                        <i class="fas fa-search"></i>
                      </button>

                      <!-- Résoudre -->
                      <button class="btn btn-sm btn-success"
                        *ngIf="getAvailableActions(complaint.status).includes('resolve')"
                        (click)="resolveComplaint(complaint)" title="Résoudre la plainte">
                        <i class="fas fa-check-circle"></i>
                      </button>

                      <!-- Fermer -->
                      <button class="btn btn-sm btn-secondary"
                        *ngIf="getAvailableActions(complaint.status).includes('close')"
                        (click)="closeComplaint(complaint)" title="Fermer la plainte">
                        <i class="fas fa-lock"></i>
                      </button>

                      <!-- Voir détails -->
                      <button class="btn btn-sm btn-primary" (click)="openDetailModal(complaint)"
                        title="Voir les détails">
                        <i class="fas fa-eye"></i>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="platformComplaints.length === 0">
                  <td colspan="7" class="text-center text-muted">Aucune plainte de plateforme trouvée</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div class="pagination-wrapper" *ngIf="starPagination.total > 0">
            <div class="row align-items-center">
              <div class="col-md-6">
                <div class="pagination-info">
                  <span>Affichage de {{ getCurrentPagination().from }} à {{ getCurrentPagination().to }} sur {{
                    getCurrentPagination().total }} plaintes</span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex justify-content-end align-items-center">
                  <select class="form-select me-3" style="width: auto;"
                    (change)="changePerPage($any($event.target).value)">
                    <option value="5" [selected]="getCurrentPagination().per_page === 5">5</option>
                    <option value="10" [selected]="getCurrentPagination().per_page === 10">10</option>
                    <option value="25" [selected]="getCurrentPagination().per_page === 25">25</option>
                    <option value="50" [selected]="getCurrentPagination().per_page === 50">50</option>
                  </select>

                  <nav aria-label="Pagination">
                    <ul class="pagination mb-0">
                      <li class="page-item" [class.disabled]="getCurrentPagination().current_page === 1">
                        <button class="page-link" (click)="changePage(getCurrentPagination().current_page - 1)"
                          [disabled]="getCurrentPagination().current_page === 1">
                          <i class="fas fa-chevron-left"></i>
                        </button>
                      </li>

                      <li class="page-item" *ngFor="let page of getPageNumbers()"
                        [class.active]="page === getCurrentPagination().current_page">
                        <button class="page-link" (click)="changePage(page)">{{ page }}</button>
                      </li>

                      <li class="page-item" [class.disabled]="pagination.current_page === pagination.last_page">
                        <button class="page-link" (click)="changePage(getCurrentPagination().current_page + 1)"
                          [disabled]="getCurrentPagination().current_page === getCurrentPagination().last_page">
                          <i class="fas fa-chevron-right"></i>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>